import axios from 'axios';
import { AUTH_API } from '../constants/api';

// Tạo instance axios riêng cho authentication
const authApi = axios.create({
    headers: {
        'Content-Type': 'application/json'
    }
});

// Service xử lý authentication
const authService = {
    // Đăng nhập
    login: async (username, password) => {
        try {
            const response = await authApi.post(AUTH_API.LOGIN, {
                username,
                password
            });
            
            if (response.data.token) {
                // Lưu token vào localStorage
                localStorage.setItem('token', response.data.token);
                localStorage.setItem('user', JSON.stringify(response.data.user));
            }
            return response.data;
        } catch (error) {
            throw error.response?.data || { message: 'Đăng nhập thất bại' };
        }
    },

    // Đăng xuất
    logout: () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
    },

    // Lấy thông tin user hiện tại
    getCurrentUser: () => {
        const userStr = localStorage.getItem('user');
        if (userStr) return JSON.parse(userStr);
        return null;
    },

    // Kiểm tra đã đăng nhập chưa
    isAuthenticated: () => {
        const token = localStorage.getItem('token');
        return !!token;
    },

    // Lấy token
    getToken: () => {
        return localStorage.getItem('token');
    }
};

export default authService; 